// components/PortfolioSharingStatus.js
import React, { useState } from 'react';
import { Box, Typography, Tooltip, ClickAwayListener } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import InfoIcon from '@mui/icons-material/Info';

const PortfolioSharingStatus = ({ privacyLevel, sharedViewMode }) => {
  const theme = useTheme();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  
  // Don't display anything if the portfolio is private
  if (privacyLevel === 'private') {
    return null;
  }
  
  // Determine background color based on privacy level and view mode
  let backgroundColor;
  let textColor = theme.palette.common.white;
  let tooltipText = '';
  
  if (privacyLevel === 'public') {
    tooltipText = sharedViewMode === 'full' 
      ? 'This portfolio is publicly accessible with full details visible' 
      : 'This portfolio is publicly accessible with limited details visible';
    backgroundColor = sharedViewMode === 'full' ? theme.palette.error.main : theme.palette.warning.main;
  } else if (privacyLevel === 'shared') {
    tooltipText = sharedViewMode === 'full' 
      ? 'This portfolio is shared with specific people with full details visible' 
      : 'This portfolio is shared with specific people with limited details visible';
    backgroundColor = sharedViewMode === 'full' ? theme.palette.error.main : theme.palette.warning.main;
  }

  const handleTooltipClose = () => {
    setTooltipOpen(false);
  };

  const handleTooltipToggle = () => {
    setTooltipOpen(!tooltipOpen);
  };
  
  return (
    <Box 
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: '16px',
        padding: '4px 12px',
        backgroundColor,
        color: textColor,
        fontSize: '0.8rem',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
        cursor: 'pointer',
      }}
    >
      <Typography variant="body2" fontWeight="medium">
        {privacyLevel === 'public' ? 'Public' : 'Shared'}
      </Typography>
      
      <ClickAwayListener onClickAway={handleTooltipClose}>
        <div>
          <Tooltip 
            title={tooltipText}
            arrow
            placement="bottom"
            open={tooltipOpen}
            disableFocusListener
            disableHoverListener
            disableTouchListener
          >
            <InfoIcon 
              fontSize="small" 
              sx={{ ml: 0.5, width: 16, height: 16 }} 
              onClick={handleTooltipToggle}
            />
          </Tooltip>
        </div>
      </ClickAwayListener>
    </Box>
  );
};

export default PortfolioSharingStatus;